import React, { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import filtersAtom from './atoms/filterAtom';
import isEmpty from 'lodash/isEmpty';
import { Retry } from '@components/common';
import ResiliencyTable from './Table';
import FilterPanel from './FilterPanel';
import TopPanel from './TopPanel';
import useResiliencyData from './useResiliencyData';
import { StyledFilterPanel, StyledResiliencyWrapper } from './styled';

function Resiliency({ interval }) {
  const [filteredResiliencyData, setFilteredResiliencyData] = useState<any[]>([]);
  const filter = useAtomValue(filtersAtom);
  const {
    resiliencyData,
    forceUpdateResiliencyData,
    isResiliencyDataLoading,
    resiliencyDataStatus,
  } = useResiliencyData({ interval, filter });

  useEffect(() => {
    if (resiliencyData) {
      const records: any[] = resiliencyData || [];
      setFilteredResiliencyData(records);
    }
  }, [resiliencyData]);

  return (
    <StyledResiliencyWrapper>
      <StyledFilterPanel>
        <FilterPanel data={filteredResiliencyData} />
      </StyledFilterPanel>
      <Retry
        isLoading={isResiliencyDataLoading}
        showError={resiliencyDataStatus === 'error'}
        isEmpty={isEmpty(filteredResiliencyData)}
        mountChildAlways={false}
        fetchData={forceUpdateResiliencyData}
      >
        <TopPanel data={filteredResiliencyData} />
        <ResiliencyTable data={filteredResiliencyData} interval={interval} />
      </Retry>
    </StyledResiliencyWrapper>
  );
}

export default React.memo(Resiliency);
